import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DetailComponent } from '../../models/detail-component';
import { TreeNodeEvent } from '../../models/tree-node-event';
import { TreeNode } from 'primeng/api';

@Component({
  selector: 'sample-detail',
  templateUrl: './sample-detail.component.html',
  styleUrls: ['./sample-detail.component.scss']
})
export class SampleDetailComponent implements OnInit, DetailComponent, OnDestroy, AfterViewInit {
  node: TreeNode;



  @ViewChild('buttons')
  private buttons: TemplateRef<any>;

  buttons$ = new EventEmitter<TemplateRef<any>>(true);

  onRequestNodeUpdate = new EventEmitter<TreeNodeEvent>();

  constructor() { }

  refresh() {
    this.onRequestNodeUpdate.next({ type: 'refresh', node: null });
  }
  toggleNode(node) {
    this.onRequestNodeUpdate.next({ type: 'toggle', node: node });
  }
  deleteNode(node) {
    this.onRequestNodeUpdate.next({ type: 'delete', node: node });
  }

  addNode() {
    const newNode = <TreeNode>{
      key: new Date().getTime().toString(),
      label: new Date().getTime().toString(),
      data: {},
      parent: this.node
    }
    this.onRequestNodeUpdate.next({ type: 'add', node: newNode });
  }

  // expand() {
  //   this.node.expanded = true;
  // }

  // collapse() {
  //   this.node.expanded = false;
  // }

  ngOnInit(): void {
    console.log(`Sample Detail Component Inited`);
  }
  ngOnDestroy(): void {
    console.log(`Sample Detail Component Destroyed`);
  }
  ngAfterViewInit() {
    this.buttons$.next(this.buttons);
  }

}
